var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Fund Profile",
    transform: "translate(12 14)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53",
    transform: "translate(-294 -1250)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(282 1236)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 1250h228a8 8 0 0 1 8 8v16H294v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 1250.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V1258a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(304 1259)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(312 1259)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(320 1259)",
    fill: "#00c243"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294 1273h244v20H294z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M294.5 1273.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(304 1278)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(464 1281)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(480 1281)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(496 1281)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(512 1281)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 140",
    d: "M478 1360h8a2 2 0 0 1 0 4h-8a2 2 0 0 1 0-4Z",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(492 1360)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(508 1360)",
    fill: "#9098a4"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 25",
    width: 209,
    height: 57,
    rx: 1,
    transform: "translate(18 43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 26",
    width: 209,
    height: 114,
    rx: 1,
    transform: "translate(18 121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ring Chart1",
    fill: "#fd0826"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M176.276 133.727a26.271 26.271 0 0 1 22.751 13.135 26.271 26.271 0 0 1 0 26.271l-4.583-2.646a20.979 20.979 0 0 0 0-20.979 20.979 20.979 0 0 0-18.168-10.489Z",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M199.028 173.137a26.271 26.271 0 0 1-34.15 10.53l2.3-4.768a20.979 20.979 0 0 0 27.267-8.412Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M164.878 183.667a26.271 26.271 0 0 1-13.056-33.267l4.926 1.933a20.979 20.979 0 0 0 10.426 26.566Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M151.817 150.4a26.271 26.271 0 0 1 24.459-16.673v5.292a20.979 20.979 0 0 0-19.529 13.314Z",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Fund Name Lorem Ipsum",
    transform: "translate(30 59)",
    fill: "#454545",
    fontSize: 10,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fund Name Lorem Ipsum")), /*#__PURE__*/React.createElement("text", {
    "data-name": "Fund allocation",
    transform: "translate(19 115)",
    fill: "#454545",
    fontSize: 8,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fund allocation")), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 27",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(30 64)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55",
    transform: "translate(-828 -1250)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(858 1391)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(858 1398)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56",
    transform: "translate(-828 -1236)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 85,
    height: 4,
    rx: 1,
    transform: "translate(858 1391)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 85,
    height: 4,
    rx: 1,
    transform: "translate(858 1398)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57",
    transform: "translate(-828 -1222)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 73,
    height: 4,
    rx: 1,
    transform: "translate(858 1391)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 73,
    height: 4,
    rx: 1,
    transform: "translate(858 1398)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58",
    transform: "translate(-828 -1208)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 82,
    height: 4,
    rx: 1,
    transform: "translate(858 1391)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 82,
    height: 4,
    rx: 1,
    transform: "translate(858 1398)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 29",
    width: 187,
    height: 4,
    rx: 1,
    transform: "translate(30 81)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 30",
    width: 120,
    height: 4,
    rx: 1,
    transform: "translate(30 88)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 28",
    width: 33,
    height: 4,
    rx: 1,
    transform: "translate(79 64)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 31",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(30 74)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(30 131)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 35",
    width: 40,
    height: 4,
    rx: 1,
    transform: "translate(30 208)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54",
    transform: "translate(177.064 53)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 13",
    width: 38,
    height: 16,
    rx: 3,
    transform: "translate(-.064)",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(4.936 10)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Subscribe"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundReport);
export default __webpack_public_path__ + "static/media/fund-report.bc34a51c985a7b99c7d569eef5c449eb.svg";
export { ForwardRef as ReactComponent };